import { render, staticRenderFns } from "./buyFundList.vue?vue&type=template&id=1ffb4405&scoped=true"
import script from "./buyFundList.vue?vue&type=script&lang=js"
export * from "./buyFundList.vue?vue&type=script&lang=js"
import style0 from "./buyFundList.vue?vue&type=style&index=0&id=1ffb4405&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb4405",
  null
  
)

export default component.exports